/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Visibilityteam1Inputs */

const zh_share_visibilityteam1 = /** @type {(inputs: Share_Visibilityteam1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队`)
};

const en_share_visibilityteam1 = /** @type {(inputs: Share_Visibilityteam1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const es_share_visibilityteam1 = /** @type {(inputs: Share_Visibilityteam1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Share_Visibilityteam1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_visibilityteam1 = /** @type {((inputs?: Share_Visibilityteam1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Visibilityteam1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_visibilityteam1(inputs)
	if (locale === "en") return en_share_visibilityteam1(inputs)
	return es_share_visibilityteam1(inputs)
});
export { share_visibilityteam1 as "share_visibilityTeam" }